import { cn } from "@gettactic/helpers/src/css/cn";
import React from "react";
import { useDataManColumn } from "../../hooks/useDataManColumn";
import { useDataMan } from "../../hooks/useDataMan";
import { DataManHeaderColumnContent } from "../common/DataManHeaderColumnContent";

export const DataManTableViewColumnTitle: React.FC = () => {
  const { isActionColumn, isSelectionColumn, isSortableHandler, column } =
    useDataManColumn();
  const { actionsColumnWidth } = useDataMan();

  const getWidthValue = () => {
    if (isActionColumn && actionsColumnWidth) {
      return typeof actionsColumnWidth === "number"
        ? `${actionsColumnWidth}px`
        : actionsColumnWidth;
    }
    if (column?.width) {
      return typeof column.width === "number"
        ? `${column.width}px`
        : column.width;
    }
    return undefined;
  };

  const widthValue = getWidthValue();

  return (
    <th
      className={cn(
        "h-9 border-y border-neutral-100",
        isActionColumn
          ? "whitespace-nowrap"
          : isSelectionColumn
            ? "w-[46px]"
            : isSortableHandler
              ? "w-10"
              : ""
      )}
      style={widthValue ? { width: widthValue, maxWidth: widthValue } : undefined}
    >
      <DataManHeaderColumnContent />
    </th>
  );
};
